<template>
    <ComponentHeaderBarDefault>
        <template v-slot:slot_nav_links>
            <div>
                <v-btn text v-bind:to="data_route_link_srp" >Report</v-btn>

                <v-divider inset vertical></v-divider>

                <v-btn text v-bind:to="data_route_link_details" >Details</v-btn>
            </div>
        </template>
    </ComponentHeaderBarDefault>
</template>

<script>
//########################################
//IMPORTS libs
//########################################

//########################################
//IMPORTS components
//########################################

//GENERIC COMPONENTS
import ComponentHeaderBarDefault from '@/components/ComponentHeaderBarDefault';

//########################################
//MAIN
//########################################
export default {
    name: 'PagesDefaultHeaderModuleBhcpf',

    components:{
        //GENERIC COMPONENTS
        ComponentHeaderBarDefault,
    },

    data: function()
    {
        return {
        }
    },

    computed:{
        //============================
        //LOCAL COMPUTED
        //============================
        data_route_link_srp:function()
        {
            return{
                name:"module_bhcpf_page_srp",
                params:{
                    username:this.$route.params.username,
                    form_name:this.$route.params.form_name,
                    form_id:this.$route.params.form_id
                }
            }
        },

        data_route_link_details:function()
        {
            return{
                name:"module_bhcpf_page_details",
                params:{
                    username:this.$route.params.username,
                    form_name:this.$route.params.form_name,
                    form_id:this.$route.params.form_id
                }
            }
        },
    }
}

//call all with signature func_imp.call(this,param_1,param_2)
//############################################
//HELPERS
//############################################

//############################################
//API_REQUESTS
//############################################

//############################################
//DATA_OPPS
//############################################

//############################################
//ACTIONS
//############################################
</script>
